import React, { useEffect, useState } from 'react';
import { DonutChart } from '../../utill/Donut_StorageChart';
import api from "../../config.json";
import { Grid, Paper, Button, Box, Typography } from "@mui/material";
import axios from 'axios';
import { ChonkyActions, FullFileBrowser, ChonkyFileActionData } from 'chonky';
import Chonkey_Folder_Manager from './chonky_Manager';

const Storagemaster = ({ user,Heading }) => {
  const [files, setFiles] = useState([]);
  const [data, Totldata] = useState({});

  const [donutData, setDonutData] = useState([]);
  
  useEffect(() =>Heading('Manage Storage'), [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await axios.get(api.api + 'ImagesFromS3');

        const Data = [{
          id: "0",
          name: "Root",
          isDir: true,
          files: result.data.ImagesByFolder.map((element, index) => ({
            id: `${index + 1}`,
            name: element.Folder,
            size: element.Size,
            value: element.Size,
            modDate: new Date(),
            isDir: true,
            icon: 'folder',  // Specify folder icon for directories
            files: element.Images.map((one, idx) => ({
              id: `${index + 1}${idx + 1}`,
              // name: one.Key.split(`QMS/${user.company}/`)[1],
              name: one.Key,

              modDate: new Date(one.LastModified),
              size: one.Size,
              value: one.Size,
              icon: 'file',  // Specify file icon for files
            }))
          })),
        }];
        let test = [...result.data.ImagesByFolder]

        // Create DonutData array
        let DonutData = test.map(element => ({
          name: element.Folder,
          value: (element.Size / (1024 * 1024)).toFixed(2),
        }));

        // Calculate the free space in MB and add it to DonutData
        DonutData.push({
          name: 'Free Space',
          value: (result.data.TotalSizeAlloted - (result.data.TotalSize / (1024 * 1024))).toFixed(2), // Ensure this returns a number
        });


        console.log(Data, "current data file", result.data);
        setDonutData(DonutData)
        Totldata(result.data);
        setFiles(Data);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, []);

 function formatSize(bytes) {
    const mb = bytes / (1024 * 1024);
    if (mb >= 1024) {
        const gb = mb / 1024;
        return `${gb.toFixed(2)} GB`;
    } else {
        return `${mb.toFixed(2)} MB`;
    }
}

  return (
    <div>
      <Grid container spacing={1} sx={{ padding: 1, marginTop: 0.1, marginLeft: 0.03, backgroundColor: "black", height: "100%" }}>
        <Grid item xs={24} md={12} sx={{ height: "60vh", padding: '20px' }}>
          <Paper style={{ backdropFilter: "blur(5px)", backgroundColor: "#ffffff2b", color: "white", overflow: "hidden", boxSizing: "border-box" }} elevation={3} sx={{ padding: 2, height: "100%" }}>

            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="55vh" // Adjust this value as needed
            >
              <Typography
                className="bolder text-center"
                style={{ fontSize: '60px', color: 'orange' }}
              >
                {`Used Space: ${formatSize(data.UsedDbSize || 0)}`}

                {/* {`${(data.TotalSize / (1024 * 1024)).toFixed(2)} MB / ${(data.TotalSizeAlloted)} MB`} */}
              </Typography>
            </Box>



          </Paper>
        </Grid>
        {/* <Grid item xs={12} md={8} sx={{ height: "60vh", padding: '20px' }}>
          <Paper style={{ backdropFilter: "blur(5px)", backgroundColor: "#ffffff2b", color: "white", overflow: "hidden", boxSizing: "border-box" }} elevation={3} sx={{ padding: 2, height: "100%" }}>

            <div className='fs-2'>
              {`DISK SPACE`}
            </div>

            <DonutChart width={500} height={500} data={donutData && donutData.length > 0 && donutData} />
          </Paper>
        </Grid> */}
        {/* <Grid item xs={12} md={12} sx={{ height: "60vh", padding: '20px' }}>
          <Paper style={{ backdropFilter: "blur(5px)", backgroundColor: "#ffffff2b", color: "white", overflow: "hidden", boxSizing: "border-box" }} elevation={3} sx={{ padding: 2, height: "100%" }}>

            {files.length > 0 && (
              <Chonkey_Folder_Manager
                data={files}

              />
            )}
          </Paper>
        </Grid> */}
      </Grid>
    </div>
  );
};

export default Storagemaster;
